import { cx } from '@vtex/admin-ui'
import type { DefaultProps } from 'typings'
import { useCollapsibleContext } from './useCollapsible.constate'

type ContentProps = DefaultProps & {
  className?: string
}

export function Content(props: ContentProps) {
  const { children, className } = props
  const { getCollapseProps } = useCollapsibleContext()
  const collapseProps = getCollapseProps()

  return (
    <div
      {...collapseProps}
      className={cx(collapseProps.className ?? '', className ?? '')}
    >
      {children}
    </div>
  )
}
